import { Component } from '@angular/core';

@Component({
  selector: 'pcs-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
}
